export default "/images/vendor/flag-icon-css/flags/1x1/ir.svg?c945dfdfaee26ad2861c09ba9c678844";